<script>
    import {clickOutside} from '../scripts/clickOutside.js';
    import {link, push} from 'svelte-spa-router';    
    import { fade, fly } from 'svelte/transition';
	
    // close menu if user clicks somewhere outside
    function handleClickOutside(event) {
		  menuOpen = false;
    }

    // close menu if user presses 'esc' key 
    function handleKeydown(event) {
      if(event.keyCode === 27)
        menuOpen = false;
	}

    let menuOpen = false;
</script>

<svelte:window on:keydown={handleKeydown}/>

<nav use:clickOutside on:click_outside={handleClickOutside} class="navbar" role="navigation" aria-label="main navigation">

    <!-- svelte-ignore a11y-missing-attribute -->
    <div class="navbar-brand">
      <a class="navbar-item" href="https://fsec.msfs.info">
        <img src="./images/fsec-logo.png" width="112" height="28">
      </a>
  
      <a on:click="{() => menuOpen = !menuOpen}" role="button" class="navbar-burger burger {menuOpen ? 'is-active':''}" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
        
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
  
    <!-- svelte-ignore a11y-missing-attribute -->
    <div id="navbarBasicExample" class="navbar-menu {menuOpen ? 'is-active':''}">
      <div class="navbar-end">

        <a href="/" class="navbar-item" use:link>
          Home
        </a>
  
        <a href="/about/" class="navbar-item" use:link>
          About
        </a>
  
      </div>
    </div>

  </nav>
  
    
